// AWS Configuration for Amplify v6
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_L3ZzST9H4',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '2e2u8520bb1ght7am0t543jgi1',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || 'us-east-1:698623aa-7512-4dee-9635-ec98c16ee930'
    }
  },
  API: {
    REST: {
      WorkflowAPI: {
        endpoint: process.env.REACT_APP_API_URL || 'https://8h02jqezvc.execute-api.us-east-1.amazonaws.com/prod',
        region: process.env.REACT_APP_REGION || 'us-east-1'
      }
    }
  }
};
